export default "<div>\n      <div data-dojo-attach-point=\"recaptcha_container\" calss=\"g-recaptcha\" ></div>\n</div>"